<script>
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import { useDateTime } from "@/composables/index.ts";
import dayjs from "dayjs";

const { dateTZ } = useDateTime();

export default {
  name: "DashboardPage",
  data() {
    return {
      perms: "dashboard",
    };
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    now() {
      if (!this.dispatcher) {
        return "";
      }

      return dateTZ(dayjs(), this.dispatcher.timezone);
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="fill-height">
    <v-row align="center" justify="center">
      Dashboard
      {{ now }}
    </v-row>
  </v-container>
</template>
